import { privateRequest } from "../axios";

export const uploadDatabaseSchemaAPI = async (file: File, dbType: string, description?: string) => {
    try {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('dbType', dbType);
        if (description) formData.append('description', description);

        const response = await privateRequest.post(
            '/database-schema/upload',
            formData
        );
        return response.data;
    } catch (error) {
        console.error('Error uploading database schema:', error);
        throw error;
    }
};

export const fetchDatabaseSchemasAPI = async () => {
    try {
        const response = await privateRequest.get('/database-schema');
        return response.data;
    } catch (error) {
        console.error('Error fetching database schemas:', error);
        throw error;
    }
};

export const deleteDatabaseSchemaAPI = async (id: string | number) => {
    try {
        const response = await privateRequest.delete(`/database-schema/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting database schema:', error);
        throw error;
    }
};
